// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessCategory_searchMidle__9vjF- {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  margin: 4rem 0 1rem;
}
@media only screen and (max-width: 43.75em) {
  .BusinessCategory_searchMidle__9vjF- {
    flex-direction: column;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/BusinessCategory/BusinessCategory.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAGI;EANJ;IAOQ,sBAAA;IACA,mBAAA;EAAN;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.searchMidle {\n    display: flex;\n    justify-content: flex-end;\n    gap: 2rem;\n    margin: 4rem 0 1rem;\n\n    @media only screen and (max-width: $bp-700) {\n        flex-direction: column;         \n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchMidle": `BusinessCategory_searchMidle__9vjF-`
};
export default ___CSS_LOADER_EXPORT___;
